import { z } from 'zod';

export const teamMemberSchema = z.object({
  team_member: z
    .object({
      name: z.string({ message: 'Name is required' }),
      email: z.string({ message: 'Email is required' }).email({ message: 'Please enter a valid email address' }),
      phone_number: z.any().optional().nullable(),
      role: z.string({ message: 'Role is required' }),
      location_ids: z.array(z.any()).optional().nullable()
    })
    .superRefine((data, ctx) => {
      if (data.role === 'location_admin') {
        if (!data.location_ids || data.location_ids.length === 0) {
          ctx.addIssue({
            path: ['location_ids'],
            code: 'custom',
            message: 'Please select at least one location'
          });
        }
      }
    })
});

export const agencyTeamMemberSchema = z.object({
  team_member: z.object({
    name: z.string({ message: 'Email is required' }),
    email: z.string({ message: 'Email is required' }).email({ message: 'Please enter a valid email address' }),
    phone_number: z.any().optional().nullable(),
    role: z.enum(['agency_admin', 'agency_admin_readonly', 'agent_builder'], {
      message: 'Role is required'
    })
  })
});
